import { kea } from 'kea'
import PropTypes from 'prop-types'

export default kea({
  dimensions: {
    windowWidth: [typeof window !== 'undefined' && window.innerWidth, window => window.innerWidth]
  },

  selectors: ({ selectors }) => ({
    isOnlyReviewNumber: [
      () => [selectors.windowWidth],
      windowWidth => windowWidth >= 659 && windowWidth <= 778,
      PropTypes.bool
    ]
  })
})
